import { render, staticRenderFns } from "./ProjectFolderDefaultCreatePage.vue?vue&type=template&id=43f201f7&"
import script from "./ProjectFolderDefaultCreatePage.vue?vue&type=script&lang=ts&"
export * from "./ProjectFolderDefaultCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports